// IM-UX-175 (IM-ADR-020): organização ativa suspensa pela administração da plataforma. O bloqueio é do servidor (403
// organization_suspended em toda rota operacional); esta tela só explica e oferece as outras organizações da pessoa.
import { useState } from 'react';
import { useAuth } from '../auth/AuthContext';
import { BrandLogo } from '../components/BrandLogo';
import { EmptyState } from '../components/States';
import { friendlyError } from '../lib/errors';

export function OrganizationSuspended() {
  const { me, logout, switchOrganization } = useAuth();
  const [error, setError] = useState<string | null>(null);
  const others = (me?.organizations ?? []).filter((o) => !o.suspended && o.id !== me?.activeOrganization?.id);
  return (
    <section className="pa-gate" aria-labelledby="page-title">
      <div className="pa-gate-card card">
        <BrandLogo variant="public" />
        <EmptyState title="Organização suspensa" glyph="lock" tone="amber">
          O acesso a <b>{me?.activeOrganization?.name}</b> está suspenso pela administração da plataforma. Os dados estão preservados; fale com o suporte da InteliMove.
        </EmptyState>
        {error && <div className="form-error" role="alert">{error}</div>}
        {others.length > 0 && (
          <div className="pa-switch-list"><span className="eyebrow">Suas outras organizações</span>
            {others.map((o) => <button key={o.id} type="button" className="secondary" onClick={() => switchOrganization(o.id).catch((e) => setError(friendlyError(e, 'Não foi possível trocar agora.')))}>{o.name}</button>)}
          </div>
        )}
        <div className="pa-gate-foot"><button type="button" className="link-btn" onClick={logout}>Sair</button></div>
      </div>
    </section>
  );
}
